import coffeePlantation from './img/coffee_plantation.jpg';

import coffeeBackground1 from './img/coffee_beans_small.jpg';
import coffeeBackground2 from './img/coffee_beans.jpg';

import { Navbar, NavbarBrand, NavItem, NavbarHeader, NavDropdown, Nav, Container, Row, Button, Col, Tab, Tabs } from 'react-bootstrap';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Spinner from 'react-bootstrap/Spinner';


import Carousel from 'react-bootstrap/Carousel';
import Image from 'react-bootstrap/Image';

//import './App.css';

function LandingPage() {
  return (
    <>

      <div className="App">

        <img src={coffeePlantation} width="100%" alt="coffee plantation" />

        <Container fluid>

          <Row>
            <Col xs="12" md="6" lg="6">

              {/*<img src={coffeeBackground} width="100%" alt="coffee plantation" />*/}

              {/*<Carousel>
                  <Carousel.Item>
                    <img src={coffeeBackground1} width="100%" alt="coffee plantation" />
                    <Carousel.Caption>
                      <h3></h3>
                      <p></p>
                    </Carousel.Caption>
                  </Carousel.Item>
                  <Carousel.Item>
                    <img src={coffeeBackground2} width="100%" alt="coffee plantation" />
                    <Carousel.Caption>
                      <h3></h3>
                      <p></p>
                    </Carousel.Caption>
                  </Carousel.Item>
                </Carousel>*/}

              <Card>
                <Card.Header>&nbsp;Head of Desk <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                /></Card.Header>
                <Card.Body>
                  <Card.Text>
                    Communication and collaboration are key to our success. Share insights, raise any concerns, and collaborate with your colleagues to identify opportunities in the market.
                  </Card.Text>
                </Card.Body>
              </Card>

              <Card>
                <Card.Header>&nbsp;Coffee Price Trend and Forecast</Card.Header>
                <Card.Body>
                  <Card.Text>
                    The 3rd quarter commenced with stability, as prices remained within a narrow range. However, significant upward movement in prices occurred during the final quarter. Unforeseen weather disruptions disrupted supplies, leading to a notable increase in coffee prices.
                  </Card.Text>
                </Card.Body>
              </Card>

              <Card>
                <Card.Header>&nbsp;Bloomberg &#x2022; Markets &#x2022; Commodities</Card.Header>
                <Card.Body>
                  <Card.Text>
                    The fluctuating premium coffee bean market remains indecisive.
                  </Card.Text>
                </Card.Body>
              </Card>

            </Col>


            <Col xs="4" md="2" lg="2">
              <Card>
                <Card.Header>&nbsp;Arabica Dec24</Card.Header>
                <Card.Body class="card-body-up">
                  <Card.Title>180 <i class="bi bi-caret-up-fill"></i></Card.Title>
                </Card.Body>
              </Card>

              <Card>
                <Card.Header>&nbsp;Arabica Dec25</Card.Header>
                <Card.Body class="card-body-up">
                  <Card.Title>230<i class="bi bi-caret-up-fill"></i></Card.Title>
                </Card.Body>
              </Card>
            </Col>


            <Col xs="4" md="2" lg="2">
              <Card>
                <Card.Header>&nbsp;Robusta Jan25</Card.Header>
                <Card.Body class="card-body-down">
                  <Card.Title>3100 <i class="bi bi-caret-down-fill"></i></Card.Title>
                </Card.Body>
              </Card>

              <Card>
                <Card.Header>&nbsp;Robusta Dec25</Card.Header>
                <Card.Body class="card-body-down">
                  <Card.Title>2800 <i class="bi bi-caret-down-fill"></i></Card.Title>
                </Card.Body>
              </Card>
            </Col>


            <Col xs="4" md="2" lg="2">

              <Card>
                <Card.Header>&nbsp;DJC Index Coffee</Card.Header>
                <Card.Body class="card-body-down">
                  <Card.Title>SPOT &#x2022; 170 <i class="bi bi-caret-down-fill"></i></Card.Title>
                </Card.Body>
              </Card>

              <Card>
                <Card.Header>&nbsp;S&P GSCI Coffee</Card.Header>
                <Card.Body class="card-body-down">
                  <Card.Title>SPOT &#x2022; 140 <i class="bi bi-caret-down-fill"></i></Card.Title>
                </Card.Body>
              </Card>


            </Col>



          </Row>

        </Container>




      </div>

    </>
  );
}

export default LandingPage;
